import { NgModule } from '@angular/core';
import { NativeStorage } from '@awesome-cordova-plugins/native-storage/ngx';

// MODULES
import { TemporaryStorageModule } from './temporary-storage';
import { PersistingStorageModule } from './persisting-storage';

import { StorageService } from './storage.service';

@NgModule({
  imports: [TemporaryStorageModule, PersistingStorageModule],
  declarations: [],
  providers: [NativeStorage, StorageService],
})
export class StorageModule {}
